module.exports = __webpack_public_path__ + "static/media/bio_age_no_eat.cc13fb96.png";